function Modal() {
  const elem = document.querySelectorAll(".js-modal")


  if(elem) {
    elem.forEach(element => {
      const toggle = element.querySelector(".js-modal-toggle")
      const content = element.querySelector(".js-modal-content")
      const close = element.querySelector(".js-modal-close")

      toggle.addEventListener("click",()=> {
        content.classList.toggle("is-open")
      })

      close.addEventListener("click",()=> {
        content.classList.toggle("is-open")
      })
      
    });
  }
  
}

export {Modal}